var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHigLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 179.52 107.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #17245f;\n      }\n\n      .cls-2 {\n        fill: #06df70;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 68.54,
    cy: 22.16,
    r: 7.03
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.35,37.32h10.93v52.22c0,1.41-1.14,2.55-2.55,2.55h-10.93V39.87c0-1.41,1.14-2.55,2.55-2.55Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.49,15.33h11.72V87.84c0,2.35-1.91,4.25-4.25,4.25h-11.72V19.58c0-2.35,1.91-4.25,4.25-4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4.25,15.33H15.97V87.84c0,2.35-1.91,4.25-4.25,4.25H0V19.58c0-2.35,1.91-4.25,4.25-4.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.75,42.98c-.11,2.29,.61,4.22,1.97,4.85,.24,.11,.55,.2,.94,.22h19.69v11.77c.01-.26,0-.7-.19-1.19-.18-.49-.44-.8-.52-.89-.11-.13-.54-.6-1.26-.83-.34-.11-.62-.12-1.19-.14-.39-.01-.71,0-.94,.01-6.17,0-12.34-.02-18.51-.02v-13.78Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.79,61.69h12.28c-.71,.95-1.49,1.86-2.35,2.72-10.05,10.14-26.48,10.21-36.62,.16-10.14-10.05-10.21-26.48-.16-36.62,10.05-10.14,26.48-10.21,36.62-.16,3.54,3.51,5.85,7.79,6.93,12.31l20.63,.06c-1.4-10.73-6.48-20.31-13.93-27.42-8.29-7.9-19.51-12.75-31.86-12.75-25.51,0-46.18,20.68-46.18,46.18,0,12.75,5.17,24.3,13.53,32.66l27.21,26.77c1.39,1.39,3.32,2.25,5.44,2.25s4.05-.86,5.44-2.26l27.2-26.76c8.36-8.36,13.53-19.91,13.53-32.66h-37.68c-1.99-.03-4.11,.84-5.49,2.26-1.43,1.38-2.31,3.5-2.28,5.49-.03,1.99,.85,4.11,2.27,5.49,1.38,1.42,3.5,2.3,5.49,2.27"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigLogo);
export default __webpack_public_path__ + "static/media/hig-logo.39c6924b.svg";
export { ForwardRef as ReactComponent };